import React, { useEffect } from "react";
import { debug } from "../../utils";
import { connect } from "react-redux";
import * as modalDataService from './modalDataService';
import * as validationService from "./validationService";

function MSTenantIdField({ msTenantId, error, disabled }) {

    //const [disableValue, setDisableValue] = useState(false)

    useEffect(() => {
        validationService.validateNotEmpty(msTenantId, 'msTenantId');
        return () => validationService.cleanValidation('msTenantId');
    }, [msTenantId])


    const onChange = (value) => modalDataService.changeMSTenantId(value);

    return (
        <div className="form-group">
            <div className="oct_form-group oct_form-sm">
                <label htmlFor="ms_tenantid">Tenant Id <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${error && 'border-danger'}`}
                    id="ms_tenantid-key"
                    disabled={disabled}
                    value={msTenantId}
                    onChange={event => onChange(event.target.value)} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("MSTenantIdField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const validation = state.validation;

    return {
        msTenantId: addDeviceModal.msTenantId || '',       
        error: validation.msTenantId
    }
}

export default connect(mapStateToProps)(MSTenantIdField);
